import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewNewIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewNew" ref={ref} {...props}>
      <path d="M18.84,6.51h-.3V6.05A3.76,3.76,0,0,0,14.79,2.3H5A3.76,3.76,0,0,0,1.25,6.05v7.69A3.76,3.76,0,0,0,5,17.49h.46v.3A3.92,3.92,0,0,0,9.37,21.7h9.47a3.92,3.92,0,0,0,3.91-3.91V10.42A3.92,3.92,0,0,0,18.84,6.51ZM5,16a2.25,2.25,0,0,1-2.25-2.25V6.05A2.25,2.25,0,0,1,5,3.8h9.79A2.25,2.25,0,0,1,17,6.05v7.69A2.25,2.25,0,0,1,14.79,16Zm16.25,1.8a2.41,2.41,0,0,1-2.41,2.41H9.37A2.41,2.41,0,0,1,7,17.79v-.3h7.83a3.76,3.76,0,0,0,3.75-3.75V8h.3a2.41,2.41,0,0,1,2.41,2.41Z" />
    </Icon>
  ),
) as IconWithRender;

ViewNewIcon.displayName = 'ViewNewIcon';
ViewNewIcon.renderIcon = (props) => <ViewNewIcon {...props} />;
export default ViewNewIcon;
